var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row align-items-center col-sm-12 p-0 m-0 pt-1"},[_c('label',{class:[
      'col-sn-6',
      'col-form-label',
      'pt-1',
      _vm.device !== 'desktop' ? 'p-0' : '',
    ]},[_vm._v(_vm._s(_vm.$t('search-tab.age')))]),_c('div',{staticClass:"col-sn-6n p-0 m-0"},[_c('b-form-select',{staticClass:"age",attrs:{"options":_vm.options},on:{"change":_vm.change},model:{value:(_vm.currValue),callback:function ($$v) {_vm.currValue=$$v},expression:"currValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }